import React from 'react';
import LocationLandingPage from './LocationLandingPage';
import { Link } from 'react-router-dom';

const KitchenCabinetsNairobi = () => (
  <LocationLandingPage
    title="Kitchen Cabinets in Nairobi | Custom Cabinet Design & Fitting"
    description="Custom kitchen cabinet services in Nairobi with modern layouts, space-saving storage, premium materials, and expert installation for residential interiors."
    path="/kitchen-cabinets-nairobi"
    h1="Kitchen Cabinets Nairobi"
    intro="We design and install custom kitchen cabinets in Nairobi to improve functionality, storage, and aesthetics for modern homes and apartments."
    serviceType="Kitchen cabinet design and fitting"
    highlights={[
      <>      <Link to="/kitchen-cabinets-nairobi">Custom kitchen cabinet design</Link>
</>,
       'for compact and large kitchens',
      'Premium board options, finishes, and fittings',
      'Smart storage planning and workflow optimization',
      'Professional installation with clean finishing standards',
    ]}
    faqs={[
      {
        question: 'Do you offer custom cabinet sizing?',
        answer: 'Yes. Every cabinet layout is measured and built for your space, appliance dimensions, and storage needs.',
      },
      {
        question: 'Can I request modern and luxury finishes?',
        answer: 'Yes. We offer contemporary, minimalist, and premium finish options based on your preferred look and budget.',
      },
    ]}
  />
);

export default KitchenCabinetsNairobi;
